<template>
    <div class="col">

        <div id="main" class="col-main">

            <div class="row no-gutters row-main justify-content-center">

                <div class="col-12 col-lg-10 bg-white">

                    <div class="row no-gutters justify-content-center">
                        <div class="col-12 col-lg-9">
                            <h2 class="section-title">
                                A warm welcome From Ealing Trailfinders Cricket Club
                            </h2>
                        </div>

                        <div class="col-12 col-lg-9">
                            <p class="h5">Our home is the impressive ground of Trailfinders Sports Club in Ealing.</p>
                            <p class="h5">We are proud to be a part of the Trailfinders sporting family, a collective of dedicated 
                                individuals and groups supporting both professional and local sport; including rugby, football, tennis, 
                                netball and of course cricket; to the community. Over the last 20 years Trailfinders Sports Club has become 
                                a hub for sport in Middlesex.</p>
                            <p class="h5">In 2021 a premier all-weather facility, including a 3-bay indoor cricket net,
                                was officially opened by Sir Andrew Strauss. Our cricket members, both 
                                seniors and juniors, benefit from premier facilities while being a part of a 
                                local, friendly cricket club. </p>

                            <p class="text-strong h5">Our Facilities</p>

                            <p class="h5">Ealing Trailfinders Cricket Club play at the impressive Trailfinders Sports Club, with the best cricket facilities in the area.</p>
                            <br/>
                            <ul class="h5">
                                <li>All Weather Indoor Centre, including a 3-bay net with viewing gallery with disabled access.</li>
                                <li>Outdoor 3-bay net facility, with bowling machine.</li>
                                <li>A dedicated cricket pavilion.</li>
                                <li>16 pitch square.</li>
                                <li>Mobile nets.</li>
                                <li>Training Kit.</li>
                                <li>Ample parking.</li>
                                <li>Multi sports facilities (at extra cost).</li>
                                <li>Gym (at extra cost).</li>
                            </ul>
                            <br/>
                            <p class="h5">Our cricket square is immaculately kept by full-time groundsmen and is fully equipped with an electronic scoreboard, covers and sight screens. 
                                For spectators bleachers are available to watch the games.</p>
                        </div>
                           
                        <div class="col-12 col-lg-9 py-5 h5">
                            <p class="section-title">
                                Welcome to Trailfinders Sports Club <br/>
                                Conferences, Meetings, Corporate Events, Weddings, Parties & Sport Facilities
                            </p>
                            <br/>
                            <p>Trailfinders Sports Club is one of West London’s premier function venues, boasting outstanding hospitality and sporting facilities 
                                at competitive rates.</p>
                            <p>This versatile venue, set in 20 acres with 3 modern pavilions, is perfect for conferences, meetings, corporate events, weddings, parties and other special occasions. 
                                Our experienced event management team are on hand with a professional and personalised service to ensure your occasion is a huge success.</p>
                            <br/>
                            <p>Trailfinders Sports Club is home to Ealing Trailfinders Rugby and Cricket courts, 5/7-a-side football/hockey pitch and gym are ideal for corporate events, sports days, 
                                weekly games sessions and fixtures whether you are a business, school, club or individual.</p>
                            <br/>
                            <p>Conveniently located in West Ealing with ample free parking, easy access from the M40 and M4 and close to public transport, you need look no further for your corporate, 
                                social or sporting needs.</p>
                            <br/>
                            <p>For more details visit <a href="https://www.tfsc.co.uk" target="_blank" rel="noreferer">https://www.tfsc.co.uk</a> or ring 0208 998 7928.</p>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
</template>
<script>
    export default {
        // data() {
        //     return {
        //         model: {}
        //     }
        // },
        // methods: {
        //     fetchList() {
        //         fetchUser('5e42c8d3a366ce0f8dfc4bf9')
        //             .then(response => {
        //                 this.model = response;
        //             })
        //     },
        // }
    }
</script>
<style>
</style>
